import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

const PROVISION_NODES_FILTER_INSTANCE_TYPES_QUERY_KEY =
  'provision-nodes-filter-instance-types';

const getProvisionNodesFilterInstanceTypesQueryKey = (
  clusterId: string,
  edgeLocationId?: string
) =>
  [
    PROVISION_NODES_FILTER_INSTANCE_TYPES_QUERY_KEY,
    clusterId,
    edgeLocationId,
  ] as const;

const getProvisionNodesFilterInstanceTypesQueryOptions = ({
  clusterId,
  edgeLocationId,
  enabled,
}: {
  clusterId: string;
  edgeLocationId?: string;
  enabled: boolean;
}) =>
  queryOptions({
    queryKey: getProvisionNodesFilterInstanceTypesQueryKey(
      clusterId,
      edgeLocationId
    ),
    queryFn: async () => {
      const { data } = await apiClient.autoscaler.getInstanceTypes({
        clusterId,
        filter: {
          edgeLocationConfigs: [{ edgeLocationId: edgeLocationId! }],
        },
      });

      return data.availableInstanceTypes || [];
    },
    enabled,
  });

export const useProvisionNodesFilterInstanceTypesQuery = ({
  clusterId,
  edgeLocationId,
}: {
  clusterId?: string;
  edgeLocationId?: string;
}) => {
  const { isLoading, data, error } = useQuery(
    getProvisionNodesFilterInstanceTypesQueryOptions({
      clusterId: clusterId ?? '',
      edgeLocationId,
      enabled: !!clusterId && !!edgeLocationId,
    })
  );

  return {
    isLoading,
    instanceTypes: data,
    error,
  };
};
